import React, {Component} from 'react';

import './styles/footer.scss';

export default class Footer extends Component {

  scrollToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  render() {
    return(
      <div className="footer">
        <div className="footer__container">
          <div className="footer__item">
            <div className="footer__logo">
              <div className="footer__logo__item">
                <img src={require('../../static/images/logo_white.svg').default} alt="" />
              </div>
              <div className="footer__logo__cross">
                <img src={require('../../static/images/icons/cross.svg').default} alt="" />
              </div>
              <div className="footer__logo__item _kai">
                <a href="https://www.instagram.com/karenartyan/" target="_blank" rel="noopener noreferrer">
                  <img src={require('../../static/images/kai_lab.svg').default} alt="" />
                </a>
              </div>
            </div>
            <div className="footer__scroll-up">
              <button onClick={this.scrollToTop}>Scroll up</button>
            </div>
          </div>
          <div className="footer__item">
            <div className="footer__links">
              <div className="footer__links__item">
                <button onClick={this.scrollToTop}>Scroll up</button>
              </div>
              <div className="footer__links__item">
                <a href="https://wayray.typeform.com/to/QDFTx3SK" target="_blank" rel="noopener noreferrer">Leave feedback</a>
              </div>
              <div className="footer__links__item">
                <a href="https://wayray.com/" target="_blank" rel="noopener noreferrer">Go to wayray.com</a>
              </div>
              <div className="footer__links__item">
                <img src={require('../../../src/static/images/icons/inst.svg').default} alt=""/>
                <p>Follow <a href="https://www.instagram.com/dodeeptech/" target="_blank" rel="noopener noreferrer">@dodeeptech</a><br />on Instagram</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}